/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import FormEntitySummaryCard from './FormEntitySummaryCard';
import { reSequenceFormEntities } from '../../../../shared/utils/dndUtils';

const useStyles = makeStyles({
  wrapper: {
    margin: '-.75rem',
  },
  card: {
    margin: '.75rem',
  },
});

export default function ListContainer(props) {
  const {
    formEntities = [],
    config,
    openDeleteDialog,
    openEditDialog,
    readOnly = false,
    schemaId,
    className,
    updateEntityOrder,
    schema,
    formContext,
    disableDragAndDrop,
  } = props;
  const classes = useStyles();
  const onDragEnd = (onDragEndResult) => {
    const pathToEntities = schemaId.split('_').splice(1);
    const schemaPath = pathToEntities[0].concat('.', pathToEntities[1]);
    updateEntityOrder(reSequenceFormEntities(onDragEndResult, formEntities), schemaPath);
    // TODO: insert configurable confirm dialog
  };

  return formEntities?.length ? (
    <div id={schemaId} className={classes.wrapper}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="local">
          {provided => (
            <div ref={provided.innerRef} className={className} {...provided.droppableProps}>
              {formEntities.map((entity, index) => (
                <Draggable key={entity.id} draggableId={entity.id} index={index} isDragDisabled={disableDragAndDrop}>
                  {providedDraggable => (
                    <div
                      ref={providedDraggable.innerRef}
                      {...providedDraggable.draggableProps}
                      {...providedDraggable.dragHandleProps}
                    >
                      <FormEntitySummaryCard
                        key={entity.id}
                        id={`${schemaId}_${index}_${entity.role?.toLowerCase()}_summaryCard`}
                        type="MINICARD"
                        entity={{ ...entity, order: index + 1 }}
                        config={config}
                        openDeleteDialog={entity.applicantId ? null : openDeleteDialog}
                        openEditDialog={entity.applicantId ? null : openEditDialog}
                        readOnly={readOnly}
                        className={classes.card}
                        schema={schema}
                        formContext={formContext}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  ) : null;
}
